export const SET_CURRENT_USER_DATA_REQUEST = "SET_CURRENT_USER_DATA_REQUEST";
export const SET_CURRENT_USER_DATA_SUCCESS = "SET_CURRENT_USER_DATA_SUCCESS";
export const SET_CURRENT_USER_DATA_FAILURE = "SET_CURRENT_USER_DATA_FAILURE";

export const SET_SWITCH_USER_DATA_REQUEST = "SET_SWITCH_USER_DATA_REQUEST";
export const SET_SWITCH_USER_DATA_SUCCESS = "SET_SWITCH_USER_DATA_SUCCESS";
export const SET_SWITCH_USER_DATA_FAILURE = "SET_SWITCH_USER_DATA_FAILURE";

export const PERFORMANCE_REQUEST = "PERFORMANCE_REQUEST";
export const PERFORMANCE_LOADED = "PERFORMANCE_LOADED";
export const SET_PERFORMANCE = "SET_PERFORMANCE";

export const LOAD_REVENUE_REPORT_DATA_REQUEST =
  "LOAD_REVENUE_REPORT_DATA_REQUEST";
export const LOAD_REVENUE_REPORT_DATA_SUCCESS =
  "LOAD_REVENUE_REPORT_DATA_SUCCESS";
export const LOAD_REVENUE_REPORT_DATA_FAILURE =
  "LOAD_REVENUE_REPORT_DATA_FAILURE";

export const LOAD_LINKS_REPORT_DATA_REQUEST = "LOAD_LINKS_REPORT_DATA_REQUEST";
export const LOAD_LINKS_REPORT_DATA_SUCCESS = "LOAD_LINKS_REPORT_DATA_SUCCESS";
export const LOAD_LINKS_REPORT_DATA_FAILURE = "LOAD_LINKS_REPORT_DATA_FAILURE";

export const SET_FILTER_LINKS_REPORT_DATA = "SET_FILTER_LINKS_REPORT_DATA";

export const SET_OBSESSED_PAGES_REQUEST = "SET_OBSESSED_PAGES_REQUEST";
export const SET_OBSESSED_PAGES_SUCCESS = "SET_OBSESSED_PAGES_SUCCESS";
export const SET_OBSESSED_PAGES_FAILURE = "SET_OBSESSED_PAGES_FAILURE";

export const SET_MORE_OBSESSED_PAGES_REQUEST =
  "SET_MORE_OBSESSED_PAGES_REQUEST";
export const SET_MORE_OBSESSED_PAGES_SUCCESS =
  "SET_MORE_OBSESSED_PAGES_SUCCESS";
export const SET_MORE_OBSESSED_PAGES_FAILURE =
  "SET_MORE_OBSESSED_PAGES_FAILURE";

export const SET_PUBLISH_OBSESSED_PAGE_REQUEST =
  "SET_PUBLISH_OBSESSED_PAGE_REQUEST";
export const SET_PUBLISH_OBSESSED_PAGE_SUCCESS =
  "SET_PUBLISH_OBSESSED_PAGE_SUCCESS";
export const SET_PUBLISH_OBSESSED_PAGE_FAILURE =
  "SET_PUBLISH_OBSESSED_PAGE_FAILURE";

export const SET_OBSESSED_PAGE_REQUEST = "SET_OBSESSED_PAGE_REQUEST";
export const SET_OBSESSED_PAGE_SUCCESS = "SET_OBSESSED_PAGE_SUCCESS";
export const SET_OBSESSED_PAGE_FAILURE = "SET_OBSESSED_PAGE_FAILURE";

export const SET_OBSESSED_BANNER_REQUEST = "SET_OBSESSED_BANNER_REQUEST";
export const SET_OBSESSED_BANNER_SUCCESS = "SET_OBSESSED_BANNER_SUCCESS";
export const SET_OBSESSED_BANNER_FAILURE = "SET_OBSESSED_BANNER_FAILURE";

export const SET_PRODUCT_COLLECTIONS_REQUEST =
  "SET_PRODUCT_COLLECTIONS_REQUEST";
export const SET_PRODUCT_COLLECTIONS_SUCCESS =
  "SET_PRODUCT_COLLECTIONS_SUCCESS";
export const SET_PRODUCT_COLLECTIONS_FAILURE =
  "SET_PRODUCT_COLLECTIONS_FAILURE";

export const SET_MERCHANT_REPORT_DATA_REQUEST =
  "SET_MERCHANT_REPORT_DATA_REQUEST";
export const SET_MERCHANT_REPORT_DATA_SUCCESS =
  "SET_MERCHANT_REPORT_DATA_SUCCESS";
export const SET_MERCHANT_REPORT_DATA_FAILURE =
  "SET_MERCHANT_REPORT_DATA_FAILURE";

export const SET_RETAILERS_LIST_REQUEST = "SET_RETAILERS_LIST_REQUEST";
export const SET_RETAILERS_LIST_SUCCESS = "SET_RETAILERS_LIST_SUCCESS";
export const SET_RETAILERS_LIST_FAILURE = "SET_RETAILERS_LIST_FAILURE";

export const SET_RETAILERS_CATEGORIES = "SET_RETAILERS_CATEGORIES";

export const SET_RETAILER_REQUEST = "SET_RETAILER_REQUEST";
export const SET_RETAILER_SUCCESS = "SET_RETAILER_SUCCESS";
export const SET_RETAILER_FAILURE = "SET_RETAILER_FAILURE";

export const SET_RETAILER_SUSTAINABILITY_RATINGS_REQUEST =
  "SET_RETAILER_SUSTAINABILITY_RATINGS_REQUEST";
export const SET_RETAILER_SUSTAINABILITY_RATINGS_SUCCESS =
  "SET_RETAILER_SUSTAINABILITY_RATINGS_SUCCESS";

export const SET_RETAILER_UPDATES_REQUEST = "SET_RETAILER_UPDATES_REQUEST";
export const SET_RETAILER_UPDATES_SUCCESS = "SET_RETAILER_UPDATES_SUCCESS";
export const SET_RETAILER_UPDATES_FAILURE = "SET_RETAILER_UPDATES_FAILURE";

export const SET_TOP_PRODUCTS_ANNOUNCEMENT_REQUEST =
  "SET_TOP_PRODUCTS_ANNOUNCEMENT_REQUEST";
export const SET_TOP_PRODUCTS_ANNOUNCEMENT_SUCCESS =
  "SET_TOP_PRODUCTS_ANNOUNCEMENT_SUCCESS";
export const SET_TOP_PRODUCTS_ANNOUNCEMENT_FAILURE =
  "SET_TOP_PRODUCTS_ANNOUNCEMENT_FAILURE";

export const SET_LINK_REQUEST = "SET_LINK_REQUEST";
export const SET_LINK_SUCCESS = "SET_LINK_SUCCESS";
export const SET_LINK_FAILURE = "SET_LINK_FAILURE";

export const ARCHIVING_LINK_REQUEST = "ARCHIVING_LINK_REQUEST";
export const ARCHIVING_LINK_SUCCESS = "ARCHIVING_LINK_SUCCESS";
export const ARCHIVING_LINK_FAILURE = "ARCHIVING_LINK_FAILURE";

export const UNARCHIVING_LINK_REQUEST = "UNARCHIVING_LINK_REQUEST";
export const UNARCHIVING_LINK_SUCCESS = "UNARCHIVING_LINK_SUCCESS";
export const UNARCHIVING_LINK_FAILURE = "UNARCHIVING_LINK_FAILURE";

export const ARCHIVING_LINK_ON_MY_LINKS_PAGE_SUCCESS =
  "ARCHIVING_LINK_ON_MY_LINKS_PAGE_SUCCESS";
export const UNARCHIVING_LINK_ON_MY_LINKS_PAGE_SUCCESS =
  "UNARCHIVING_LINK_ON_MY_LINKS_PAGE_SUCCESS";

export const SET_LOGOUT_REQUEST = "SET_LOGOUT_REQUEST";
export const SET_LOGOUT_SUCCESS = "SET_LOGOUT_SUCCESS";
export const SET_LOGOUT_FAILURE = "SET_LOGOUT_FAILURE";

// MagicLinks API Authentication
export const MAGICLINKS_API_LOGIN_REQUEST = "MAGICLINKS_API_LOGIN_REQUEST";
export const MAGICLINKS_API_LOGIN_SUCCESS = "MAGICLINKS_API_LOGIN_SUCCESS";
export const MAGICLINKS_API_LOGIN_FAILURE = "MAGICLINKS_API_LOGIN_FAILURE";
export const MAGICLINKS_API_LOGOUT = "MAGICLINKS_API_LOGOUT";
export const MAGICLINKS_API_VALIDATE_TOKEN_SUCCESS =
  "MAGICLINKS_API_VALIDATE_TOKEN_SUCCESS";

export const GET_FAVORITE_RETAILERS_REQUEST = "GET_FAVORITE_RETAILERS_REQUEST";
export const GET_FAVORITE_RETAILERS_SUCCESS = "GET_FAVORITE_RETAILERS_SUCCESS";
export const GET_FAVORITE_RETAILERS_FAILURE = "GET_FAVORITE_RETAILERS_FAILURE";
export const SET_FAVORITE_RETAILERS_REQUEST = "SET_FAVORITE_RETAILERS_REQUEST";
export const SET_FAVORITE_RETAILERS_SUCCESS = "SET_FAVORITE_RETAILERS_SUCCESS";
export const SET_FAVORITE_RETAILERS_FAILURE = "SET_FAVORITE_RETAILERS_FAILURE";

export const GET_LINK_GROUPS_REQUEST = "GET_LINK_GROUPS_REQUEST";
export const GET_LINK_GROUPS_SUCCESS = "GET_LINK_GROUPS_SUCCESS";
export const GET_LINK_GROUPS_FAILURE = "GET_LINK_GROUPS_FAILURE";

export const GET_LINK_GROUP_REQUEST = "GET_LINK_GROUP_REQUEST";
export const GET_LINK_GROUP_SUCCESS = "GET_LINK_GROUP_SUCCESS";
export const GET_LINK_GROUP_FAILURE = "GET_LINK_GROUP_FAILURE";

export const SET_LINK_GROUPS_REQUEST = "SET_LINK_GROUPS_REQUEST";
export const SET_LINK_GROUPS_SUCCESS = "SET_LINK_GROUPS_SUCCESS";
export const SET_LINK_GROUPS_FAILURE = "SET_LINK_GROUPS_FAILURE";

export const ADD_PRODUCT_TO_LINK_GROUP_REQUEST =
  "ADD_PRODUCT_TO_LINK_GROUP_REQUEST";
export const ADD_PRODUCT_TO_LINK_GROUP_SUCCESS =
  "ADD_PRODUCT_TO_LINK_GROUP_SUCCESS";
export const ADD_PRODUCT_TO_LINK_GROUP_FAILURE =
  "ADD_PRODUCT_TO_LINK_GROUP_FAILURE";

export const REORDER_PRODUCT_TO_LINK_GROUP_REQUEST =
  "REORDER_PRODUCT_TO_LINK_GROUP_REQUEST";
export const REORDER_PRODUCT_TO_LINK_GROUP_SUCCESS =
  "REORDER_PRODUCT_TO_LINK_GROUP_SUCCESS";
export const REORDER_PRODUCT_TO_LINK_GROUP_FAILURE =
  "REORDER_PRODUCT_TO_LINK_GROUP_FAILURE";

export const SET_LINK_GROUPS_LIMIT_EXCEEDED = "SET_LINK_GROUPS_LIMIT_EXCEEDED";
export const SET_GROUP_PUBLISHED_NOTIFICATION =
  "SET_GROUP_PUBLISHED_NOTIFICATION";

export const SET_CONFIRMATION_CODE_REQUEST = "SET_CONFIRMATION_CODE_REQUEST";
export const SET_CONFIRMATION_CODE_SUCCESS = "SET_CONFIRMATION_CODE_SUCCESS";
export const SET_CONFIRMATION_CODE_FAILURE = "SET_CONFIRMATION_CODE_FAILURE";

export const SET_USER_SIGNUP_REQUEST = "SET_USER_SIGNUP_REQUEST";
export const SET_USER_SIGNUP_SUCCESS = "SET_USER_SIGNUP_SUCCESS";
export const SET_USER_SIGNUP_FAILURE = "SET_USER_SIGNUP_FAILURE";

export const SET_USER_SIGNUP_CONFIRM_CODE_REQUEST =
  "SET_USER_SIGNUP_CONFIRM_CODE_REQUEST";
export const SET_USER_SIGNUP_CONFIRM_CODE_SUCCESS =
  "SET_USER_SIGNUP_CONFIRM_CODE_SUCCESS";
export const SET_USER_SIGNUP_CONFIRM_CODE_FAILURE =
  "SET_USER_SIGNUP_CONFIRM_CODE_FAILURE";

export const SET_USER_SIGNUP_SEND_CODE_REQUEST =
  "SET_USER_SIGNUP_SEND_CODE_REQUEST";
export const SET_USER_SIGNUP_SEND_CODE_SUCCESS =
  "SET_USER_SIGNUP_SEND_CODE_SUCCESS";
export const SET_USER_SIGNUP_SEND_CODE_FAILURE =
  "SET_USER_SIGNUP_SEND_CODE_FAILURE";

export const SET_VALIDATE_SOCIAL_CHANNEL_REQUEST =
  "SET_VALIDATE_SOCIAL_CHANNEL_REQUEST";
export const SET_VALIDATE_SOCIAL_CHANNEL_SUCCESS =
  "SET_VALIDATE_SOCIAL_CHANNEL_SUCCESS";
export const SET_VALIDATE_SOCIAL_CHANNEL_FAILURE =
  "SET_VALIDATE_SOCIAL_CHANNEL_FAILURE";

export const SET_USER_SIGNUP_REVIEW_HAS_ERROR =
  "SET_USER_SIGNUP_REVIEW_HAS_ERROR";

export const SET_USER_SIGNUP_REGISTRATION_REQUEST =
  "SET_USER_SIGNUP_REGISTRATION_REQUEST";
export const SET_USER_SIGNUP_REGISTRATION_SUCCESS =
  "SET_USER_SIGNUP_REGISTRATION_SUCCESS";
export const SET_USER_SIGNUP_REGISTRATION_FAILURE =
  "SET_USER_SIGNUP_REGISTRATION_FAILURE";

export const SET_USER_SIGNUP_STEP_REQUEST = "SET_USER_SIGNUP_STEP_REQUEST";
export const SET_USER_SIGNUP_STEP_SUCCESS = "SET_USER_SIGNUP_STEP_SUCCESS";
export const SET_USER_SIGNUP_STEP_FAILURE = "SET_USER_SIGNUP_STEP_FAILURE";

export const GET_SIGNUP_LANGS_REQUEST = "GET_SIGNUP_LANGS_REQUEST";
export const GET_SIGNUP_LANGS_SUCCESS = "GET_SIGNUP_LANGS_SUCCESS";
export const GET_SIGNUP_LANGS_FAILURE = "GET_SIGNUP_LANGS_FAILURE";

export const SET_LINK_MANAGER_USERS_REQUEST = "SET_LINK_MANAGER_USERS_REQUEST";
export const SET_LINK_MANAGER_USERS_SUCCESS = "SET_LINK_MANAGER_USERS_SUCCESS";
export const SET_LINK_MANAGER_USERS_FAILURE = "SET_LINK_MANAGER_USERS_FAILURE";
export const SET_LINK_MANAGER_INVITE_REQUEST =
  "SET_LINK_MANAGER_INVITE_REQUEST";
export const SET_LINK_MANAGER_INVITE_SUCCESS =
  "SET_LINK_MANAGER_INVITE_SUCCESS";
export const SET_LINK_MANAGER_INVITE_FAILURE =
  "SET_LINK_MANAGER_INVITE_FAILURE";
export const SET_USER_PERFORMANCE_VISIBILITY_REQUEST =
  "SET_USER_PERFORMANCE_VISIBILITY_REQUEST";
export const SET_USER_PERFORMANCE_VISIBILITY_SUCCESS =
  "SET_USER_PERFORMANCE_VISIBILITY_SUCCESS";
export const SET_USER_PERFORMANCE_VISIBILITY_FAILURE =
  "SET_USER_PERFORMANCE_VISIBILITY_FAILURE";
export const GET_LINK_MANAGER_REVENUE_REQUEST =
  "GET_LINK_MANAGER_REVENUE_REQUEST";
export const GET_LINK_MANAGER_REVENUE_SUCCESS =
  "GET_LINK_MANAGER_REVENUE_SUCCESS";
export const GET_LINK_MANAGER_REVENUE_FAILURE =
  "GET_LINK_MANAGER_REVENUE_FAILURE";

export const GET_TOP_LINKS_REQUEST = "GET_TOP_LINKS_REQUEST";
export const GET_TOP_LINKS_SUCCESS = "GET_TOP_LINKS_SUCCESS";
export const GET_TOP_LINKS_FAILURE = "GET_TOP_LINKS_FAILURE";

export const SET_LINK_CATEGORIES_REQUEST_DATA_SUCCESS =
  "SET_LINK_CATEGORIES_REQUEST_DATA_SUCCESS";
export const LOAD_LINK_CATEGORIES_REQUEST = "LOAD_LINK_CATEGORIES_REQUEST";
export const LOAD_LINK_CATEGORIES_REQUEST_DATA_FAILURE =
  "LOAD_LINK_CATEGORIES_REQUEST_DATA_FAILURE";
export const NEW_REWARDS_LINK_CATEGORY_SUCCESS =
  "NEW_REWARDS_LINK_CATEGORY_SUCCESS";
export const NEW_REWARDS_LINK_CATEGORY_FAILURE =
  "NEW_REWARDS_LINK_CATEGORY_FAILURE";
export const NEW_REWARDS_LINK_ADD_LINK_CATEGORY_SUCCESS =
  "NEW_REWARDS_LINK_ADD_LINK_CATEGORY_SUCCESS";
export const NEW_REWARDS_LINK_ADD_LINK_CATEGORY_FAILURE =
  "NEW_REWARDS_LINK_ADD_LINK_CATEGORY_FAILURE";
export const ADD_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST =
  "ADD_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST";
export const ADD_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST_SUCCESS =
  "ADD_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST_SUCCESS";
export const ADD_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST_FAILURE =
  "ADD_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST_FAILURE";

export const REMOVE_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST =
  "REMOVE_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST";
export const REMOVE_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST_SUCCESS =
  "REMOVE_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST_SUCCESS";
export const REMOVE_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST_FAILURE =
  "REMOVE_MULTIPLE_LINKS_TO_CATEGORIES_REQUEST_FAILURE";

export const GET_INVITATION_CODE_REQUEST = "GET_INVITATION_CODE_REQUEST";
export const GET_INVITATION_CODE_SUCCESS = "GET_INVITATION_CODE_SUCCESS";
export const GET_INVITATION_CODE_FAILURE = "GET_INVITATION_CODE_FAILURE";

export const ADD_LINK_TO_SECTION_REQUEST = "ADD_LINK_TO_SECTION_REQUEST";
export const REMOVE_LINK_FROM_SECTION_REQUEST =
  "REMOVE_LINK_FROM_SECTION_REQUEST";
